(function ($) {
  'use strict';

  function mainSlider() {
    var $slideshow = $('.home-slider');
    $slideshow.owlCarousel({
      animateOut: 'fadeOut',
      animateIn: 'fadeIn',
      mouseDrag: false,
      items: 1,
      margin: 0,
      stagePadding: 0,
      smartSpeed: 450,
      nav: false,
      loop: true,
      lazyContent: true,
      autoplay: true,
      autoplayTimeout: 5000
    });
  }

  function owlSlider() {
    $('.related-products-items.owl-carousel').owlCarousel({
      loop: false,
      margin: 15,
      nav: true,
      dots: false,
      lazyLoad: true,
      responsiveClass: true,

      responsive: {
        0: {
          items: 2,
          margin: 5,
          nav: true
        },
        600: {
          items: 3,
          margin: 10,
          nav: true
        },
        1000: {
          items: 4,
          nav: true
        }
      }
    })
    $('.home-video__slider').owlCarousel({
      loop: false,
      margin: 20,
      nav: true,
      dots: false,
      lazyLoad: true,
      responsiveClass: true,

      responsive: {
        0: {
          items: 1,
          margin: 10,
          loop: true,
                 stagePadding: 20,
          nav: false
        },
                480: {
          items: 1,
          margin: 10,
                  loop: true,
                 stagePadding: 30,
          nav: false
        },
        768: {
          items: 2,
          margin: 10,
          nav: true
        },
        1000: {
          items: 2,
          nav: true
        }
      }
    })
    // Post Slider
    $('.home-post__slider').owlCarousel({
      loop: false,
      margin: 20,

      nav: true,
      dots: false,
      lazyLoad: true,
      responsiveClass: true,

      responsive: {
        0: {
          items: 1,

          nav: true
        },
        600: {
          items: 2,
      
          nav: true
        },
        1000: {
          items: 2,
          nav: true
        }
      }
    })
     // Grid Images Slider

    //Home Product Slider
    $('.home-products__slider').owlCarousel({
      loop: false,
      margin: 0,
      nav: true,
      dots: true,
      lazyLoad: true,
      responsiveClass: true,

      responsive: {
        0: {
          items: 1,
          margin: 0,
          nav: true,
          dots: true
        },
        600: {
          items: 2,
          margin: 0,
          nav: true,
          dots: true
        },
        1000: {
          items: 3,
          nav: true,
          dots: true
        }
      }
    })
    //Cart Product Slider
    $('.cart-products__slider').owlCarousel({
      loop: false,
      margin: 20,
      nav: true,
      dots: false,
      lazyLoad: true,
      responsiveClass: true,
      responsive: {
        0: {
          items: 2,
          margin: 10,
          stagePadding: 15,
          nav: false
        },
                480: {
          items: 2,
          margin: 15,
                  stagePadding: 20,
          nav: false
        },
        768: {
          items: 3,
          margin: 15,
          nav: true
        },
        1000: {
          items: 4,
          nav: true
        }
      }
    })
    //Charity Card Page
    $('.page-charity-card-slideshow').owlCarousel({
      animateOut: 'fadeOut',
      animateIn: 'fadeIn',
      mouseDrag: false,
      items: 1,
      margin: 0,
      stagePadding: 0,
      smartSpeed: 450,
      nav: true,
      loop: true,
      lazyContent: true,
      autoplay: true,
      autoplayTimeout: 5000
    })
  }

  function scrollHash() {
    $("a.scroll-hash").on('click', function (event) {

      // Make sure this.hash has a value before overriding default behavior
      if (this.hash !== "") {
        // Prevent default anchor click behavior
        event.preventDefault();

        // Store hash
        var hash = this.hash;

        // Using jQuery's animate() method to add smooth page scroll
        // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
        $('html, body').animate({
          scrollTop: $(hash).offset().top - 180
        }, 1000, function () {

          // Add hash (#) to URL when done scrolling (default click behavior)
          //window.location.hash = hash;
        });
      } // End if
    });
  }




  function accordionTabs() {
    $('.accordion').accordion({
      "transitionSpeed": 100
    });
  }

  //Sticky Header
   var stickyNav = function () {
    var stickyElement = $(".site-header"),
        stickyClass = "isStuck",
        stickyPos = stickyElement.offset().top, //Distance from the top of the window.
        stickyHeight;

    //Create a negative margin to prevent content 'jumps':
    stickyElement.after('<div class="jumps-prevent"></div>');
    function jumpsPrevent() {
      stickyHeight = stickyElement.innerHeight();
      stickyElement.css({"margin-bottom":"-" + stickyHeight + "px"});
      stickyElement.next().css({"padding-top": + stickyHeight + "px"});
    };
    jumpsPrevent(); //Run.

    //Function trigger:
    $(window).resize(function(){
      jumpsPrevent();
    });

    //Sticker function:
    function stickerFn() {
      var winTop = $(window).scrollTop();
      //Check element position:

      if (stickyPos < 0 && winTop == 0) {
        stickyElement.removeClass(stickyClass);
      } else if (winTop >= stickyPos && winTop != 0){
        stickyElement.addClass(stickyClass);
      } else if (winTop == 0 && stickyPos == 0){
        stickyElement.removeClass(stickyClass);
      } else {
        stickyElement.removeClass(stickyClass);
      }
    };
    stickerFn(); //Run.

    //Function trigger:
    $(window).scroll(function(){
      stickerFn();
    });
   }
   // End Sticky Header

  function testimonial() {
    $('.testimonial-slider').owlCarousel({
      animateOut: 'fadeOut',
      animateIn: 'fadeIn',
      mouseDrag: false,
      items: 1,
      margin: 0,
      stagePadding: 0,
      smartSpeed: 450,
      nav: true,
      loop: true,
      lazyContent: true,
      autoplay: true,
      autoplayTimeout: 7000,
      autoHeight: true,

      responsive: {
        0: {
          nav: false,
          dots: true
        },
        600: {
          nav: false,
          dots: true
        },
        1000: {
          nav: true,
          dots: true
        }
      }
    });
  }

  function ctaPopup() {
    $('.cta__btn').magnificPopup({
      type: 'inline',

      fixedContentPos: true,
      fixedBgPos: true,

      overflowY: 'auto',

      closeBtnInside: true,
      preloader: false,

      midClick: true,
      removalDelay: 300,
      mainClass: 'cta-popup__container my-mfp-slide-bottom'
    });
  }

  function videoPopup() {
    $('.video--popup').magnificPopup({
      disableOn: false,
      type: 'iframe',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,

      fixedContentPos: false
    });
  }

  function searchToggle() {
    var searchContainer = $('#header-search-bar'),
        searchOpen = $('.site-header__search-trigger'),
        searchClose = searchContainer.find('.site-header__search-close');

    searchOpen.click(function(evt){
      evt.preventDefault();

      if (searchContainer.hasClass('active')) {
        searchContainer.removeClass('active');
      } else {
        searchContainer.addClass('active');
        setTimeout(function(){
        searchContainer.find('input#search-bar__input').is(":focus");
        }, 500);
      }
    })

    searchClose.click(function () {
      searchContainer.removeClass('active');
    });
  }

  /* Sale bar */
  function hideSaleBar() {
    $('html').removeClass('sale-banner-enabled');
  }

  function showSaleBar() {
    $('html').addClass('sale-banner-enabled');
  }

  if (sessionStorage.getItem('pvSalePopup') != 'hidden') {
    showSaleBar();
  }

  window.onload = function(e){
    var clockDate = $('.sale-bar__timer').data('date'),
        clockTime = $('.sale-bar__timer').data('time'),
        eventTime = moment(clockDate+ ' ' +clockTime, 'MM-DD-YYYY HH:mm:ss U').unix(),
        currentTime = moment().unix(),
        diffTime = eventTime - currentTime,
        duration = moment.duration(diffTime * 1000, 'milliseconds'),
        interval = 1000;

    var $d = $('[data-timer-days]'),
        $h = $('[data-timer-hours]'),
        $m = $('[data-timer-minutes]'),
        $s = $('[data-timer-seconds]');

    setInterval(function(){

        duration = moment.duration(duration.asMilliseconds() - interval, 'milliseconds');
        var d = moment.duration(duration).days(),
            h = moment.duration(duration).hours(),
            m = moment.duration(duration).minutes(),
            s = moment.duration(duration).seconds();

        d = $.trim(d).length === 1 ? '0' + d : d;
        h = $.trim(h).length === 1 ? '0' + h : h;
        m = $.trim(m).length === 1 ? '0' + m : m;
        s = $.trim(s).length === 1 ? '0' + s : s;

        $d.text(d);
        $h.text(h);
        $m.text(m);
        $s.text(s);

    }, interval);

    $('[data-promo-timer-close]').on('click',function() {
      hideSaleBar();
      sessionStorage.setItem('pvSalePopup', 'hidden');
    });

};
/* End sale bar */

  function mobileFooter() {
    $('.site-footer__column > h3 > .mobile-clicker').click(function () {
      var $this = $(this).parents('.site-footer__column');
      $this.siblings().removeClass('open');

      if ($this.hasClass('open')) {
        $this.removeClass('open');
      } else {
        $this.addClass('open');
      }
    })
  }

  $(document).ready(function () {
    searchToggle();
    scrollHash();
    ctaPopup();
    new WOW().init();
    testimonial();
    owlSlider();
    mainSlider();

    videoPopup();
    accordionTabs();
    //stickyNav();
    mobileFooter();
    
    $('.btn--notify').magnificPopup({
                items: {
            src: '#notify-me'
          },
      type: 'inline',

      fixedContentPos: true,
      fixedBgPos: true,

      overflowY: 'auto',

      closeBtnInside: true,
      preloader: false,

      midClick: true,
      removalDelay: 300,
      mainClass: 'notify-me__popup'
    });
    
    $('.tooltip').tooltipster({
      animation: 'fade',
      delay: 100,
      contentCloning: true,
      theme: 'tooltipster-shadow'
    });

    lazySizes.init();

    $(window).load(function(){
      $('.preloader').addClass('none');
    });

    $('.site-nav--has-dropdown > a').click(function (e) {
      e.preventDefault();
      var $this = $(this).parent(),
          $navOverlay = $('#NavOverlay');
      $this.siblings().removeClass('dropdown--active');
      $navOverlay.removeClass('nav-overlay--active');
      if ($this.hasClass('dropdown--active')) {
        $navOverlay.removeClass('nav-overlay--active');
        $this.removeClass('dropdown--active').parents('.site-header').removeClass('header--active');
      } else {
        $navOverlay.addClass('nav-overlay--active');
        $this.addClass('dropdown--active').parents('.site-header').addClass('header--active');
      }

    });

    $('#NavOverlay').click(function () {
      var $this = $(this);
      $this.removeClass('nav-overlay--active');
      $('.site-nav--has-dropdown').removeClass('dropdown--active').parents('.site-header').removeClass('header--active');
    });
$(".product-single__controls").stickUp({topMargin:0})

$('.icon__share').click(function (e) {
e.preventDefault();
   e.stopPropagation()
  var $this = $(this).parent();
      if ($this.hasClass('active')) {
        $this.removeClass('active');
      }else{
       $this.addClass('active');
      }
});
        $(document).on("click", function (e) {
        if ($(e.target).is(".product__share") === false) {
            $(".product__share").removeClass("active");
        }
    });
  });

  $(window).load(function () {
    //$('body').css('opacity', '1');
    $('.cart-item__qty .js-qty__adjust').click(function () {
      $('.update-cart').trigger('click');
      console.log('clicked update');
    });
  });
  
  
  $('#centerDiv ul.tabs').each(function(){
    var active, content, links = $(this).find('a');
    active = links.first().addClass('active');
    content = $(active.attr('href'));
    links.not(':first').each(function () {
      $($(this).attr('href')).hide();
    });
    $(this).find('a').click(function(e){
      active.removeClass('active');
      content.hide();
      active = $(this);
      content = $($(this).attr('href'));
      active.addClass('active');
      content.show();
      return false;
    });
  });
})(jQuery);

